import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 485.411 485.411",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 485.411 485.411\" id=\"email\">\r\n<g>\r\n\t<path d=\"M0,81.824v321.763h485.411V81.824H0z M242.708,280.526L43.612,105.691h398.187L242.708,280.526z\r\n\t\t M163.397,242.649L23.867,365.178V120.119L163.397,242.649z M181.482,258.533l61.22,53.762l61.22-53.762L441.924,379.72H43.487\r\n\t\tL181.482,258.533z M322.008,242.655l139.535-122.536v245.059L322.008,242.655z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol